import { api } from '..'

export const deleteDashboard = (dashboardId?: string) => () =>
  api.put(`/v1/dashboards/${dashboardId}/remove`)
